<theme-switcher *ngIf="isEmbedded" style="display: none"></theme-switcher>
<div
  class="table-outer-wrapper"
  [class.embed-view]="isEmbedded"
  [class.p-datatable-scrollable-body]="isCypress"
  [style.overflow]="isCypress ? 'auto' : null"
  [style.maxHeight]="
    isCypress ? (isEmbedded ? '100vh' : 'calc(100vh - 300px)') : null
  "
  [hidden]="!canView"
>
  <p-table
    #dataTable
    styleClass="repayments-data-table"
    stripedRows
    showGridlines
    [value]="repayments"
    [(selection)]="selectedRepayments"
    (onRowSelect)="onRowSelectionChanged()"
    (onRowUnselect)="onRowSelectionChanged()"
    [sortField]="sortField"
    [sortOrder]="sortOrder"
    (onFilter)="onFilter($event)"
    dataKey="id"
    [rowHover]="true"
    [showCurrentPageReport]="true"
    [rows]="100"
    [filterDelay]="0"
    [columns]="columns"
    (onSort)="onTableSort($event)"
    [scrollHeight]="'flex'"
    scrollable="true"
    [lazy]="true"
    [resizableColumns]="true"
    columnResizeMode="expand"
    [attr.aria-busy]="isLoading"
  >
    <ng-template #caption>
      <!-- <h1 class="text-2xl font-bold">{{ sourceFileName }}</h1> -->
      <div class="flex justify-between table-caption">
        <div class="action-buttons">
          <div class="buttons-left">
            <p-button
              [outlined]="true"
              icon="pi pi-filter-slash"
              label="Clear"
              class="clear-button"
              type="button"
              (click)="clear(dataTable)"
            />
            <p-button
              *ngIf="!sourceFileId"
              [outlined]="true"
              icon="pi pi-plus"
              label="New"
              class="new-button"
              type="button"
              (click)="addEmptyRow()"
              [disabled]="!canEdit"
            />
          </div>
          <div class="buttons-center">
            <p-button
              icon="pi pi-eye"
              [label]="
                !showDeletedOnly ? 'Deleted Repayments' : 'Active Repayments'
              "
              [variant]="!showDeletedOnly ? 'text' : null"
              class="deleted-repayments-button"
              (click)="toggleDeletedRepayments(dataTable)"
              [disabled]="!canView"
            />
            <p-button
              icon="pi pi-exclamation-triangle"
              label="Missing Fields"
              [variant]="missingFieldsOnly ? null : 'text'"
              class="missing-fields-button"
              (click)="toggleMissingFields(dataTable)"
              [disabled]="!canView"
            />
          </div>
          <div class="buttons-right">
            <div
              *ngIf="hasSelectedRepayments"
              class="p-badge p-component p-badge-info mr-2 selected-count"
            >
              <span class="count-number">{{ selectedRepaymentsCount }}</span>
              {{ selectedRepaymentsCount ? 'Repayments' : '' }}
            </div>
            <p-button
              severity="info"
              label="Edit"
              icon="pi pi-pencil"
              class="edit-button"
              outlined
              (onClick)="bulkEditRepayments($event)"
              [loading]="isBulkActionPending('edit')"
              [disabled]="
                !canEdit ||
                !hasSelectedRepayments ||
                isBulkActionPending('edit')
              "
            />
            @if (hasPendingChanges) {
              <p-button
                severity="success"
                [label]="bulkSaveLabel"
                icon="pi pi-save"
                class="commit-all-button"
                (onClick)="commitAllChanges()"
                [loading]="isBulkActionPending('commit')"
                [disabled]="!canEdit || isBulkActionPending('commit')"
              />
            }
            @if (selectedRepayments?.length && allSelectedDeleted) {
              <p-button
                severity="danger"
                label="Undo Delete"
                icon="pi pi-undo"
                class="delete-button"
                outlined
                (onClick)="undoDeleteSelectedRepayments($event)"
                [loading]="isBulkActionPending('undo-delete')"
                [disabled]="
                  !canDelete ||
                  !selectedRepayments ||
                  !selectedRepayments.length ||
                  isWholeFileSelection ||
                  isBulkActionPending('undo-delete')
                "
              />
            } @else {
              <p-button
                severity="danger"
                label="Delete"
                icon="pi pi-trash"
                class="delete-button"
                outlined
                (onClick)="deleteSelectedRepayments($event)"
                [loading]="isBulkActionPending('delete')"
                [disabled]="
                  !canDelete ||
                  !selectedRepayments ||
                  !selectedRepayments.length ||
                  isWholeFileSelection ||
                  isBulkActionPending('delete')
                "
              />
            }
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #header>
      <tr>
        <th pResizableColumn style="width: 34.5px !important">
          <p-tableHeaderCheckbox
            [disabled]="!canEdit && !canDelete"
            (onChange)="onHeaderSelectionChange($event)"
          />
        </th>
        <th pResizableColumn pSortableColumn="repayment_date">
          <div class="flex justify-between items-center">
            Repayment Date
            <p-sortIcon field="repayment_date" />
            <p-columnFilter
              type="date"
              field="repayment_date"
              display="menu"
              class="ml-auto"
            >
              <ng-template
                pTemplate="filter"
                let-value
                let-filter="filterCallback"
              >
                <p-datepicker
                  [ngModel]="value"
                  (ngModelChange)="filter($event)"
                  dateFormat="dd/mm/yy"
                  dataType="date"
                  [showIcon]="true"
                  [locale]="dateLocale"
                  styleClass="w-full"
                />
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th pResizableColumn pSortableColumn="description">
          <div class="flex justify-between items-center">
            Description
            <p-sortIcon field="description" />
            <p-columnFilter
              field="description"
              matchMode="in"
              display="menu"
              [showMatchModes]="false"
              [showOperator]="false"
              [showAddButton]="false"
              [showClearButton]="false"
              [showApplyButton]="false"
              class="ml-auto"
            >
              <ng-template
                pTemplate="filter"
                let-value
                let-filter="filterCallback"
              >
                <p-multiSelect
                  [options]="descriptionOptions"
                  optionLabel="label"
                  optionValue="value"
                  [filter]="true"
                  filterBy="label"
                  [ngModel]="value"
                  (onChange)="filter($event.value)"
                  (onClear)="filter([])"
                  [showClear]="true"
                  placeholder="Select descriptions"
                  styleClass="w-full"
                />
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        @if (!sourceFileId) {
          <th pResizableColumn pSortableColumn="previous_balance">
            <div class="flex justify-between items-center">
              Previous Balance
              <p-sortIcon field="previous_balance" />
            </div>
          </th>
        }
        <th pResizableColumn pSortableColumn="payment_amount">
          <div class="flex justify-between items-center">
            Amount
            <p-sortIcon field="payment_amount" />
            <p-columnFilter
              field="payment_amount"
              type="numeric"
              matchMode="equals"
              display="menu"
              class="ml-auto"
            >
              <ng-template
                pTemplate="filter"
                let-value
                let-filter="filterCallback"
              >
                <p-inputNumber
                  [ngModel]="value"
                  mode="currency"
                  currency="GBP"
                  locale="en-GB"
                  (ngModelChange)="onAmountFilterChange($event, filter)"
                  (onInput)="onAmountFilterChange($event.value ?? null, filter)"
                />
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        @if (!sourceFileId) {
          <th pResizableColumn pSortableColumn="balance">
            <div class="flex justify-between items-center">
              Current Balance
              <p-sortIcon field="balance" />
            </div>
          </th>
        }
        <th pResizableColumn pSortableColumn="card_transactions">
          <div class="flex justify-between items-center">
            Card Transactions
            <p-sortIcon field="card_transactions" />
          </div>
        </th>
        <th pResizableColumn pSortableColumn="data_source">
          <div class="flex justify-between items-center">
            Data Source
            <p-sortIcon field="data_source" />
          </div>
        </th>
        <th pResizableColumn pSortableColumn="x365_split">
          <div class="flex justify-between items-center">
            365 Split %
            <p-sortIcon field="x365_split" />
          </div>
        </th>
        <th pResizableColumn>
          <div class="flex justify-between items-center">Comments</div>
        </th>
        <th pResizableColumn pSortableColumn="terminals(name)">
          <div class="flex justify-between items-center">
            Terminal
            <p-sortIcon field="terminals(name)" />
          </div>
        </th>
        <th pResizableColumn pSortableColumn="cash_advances(name)">
          <div class="flex justify-between items-center">
            Cash Advance
            <p-sortIcon field="cash_advances(name)" />
          </div>
        </th>
        <th pResizableColumn pSortableColumn="merchants(name)">
          <div class="flex justify-between items-center">
            Merchant
            <p-sortIcon field="merchants(name)" />
          </div>
        </th>
        <th pResizableColumn pSortableColumn="created_date_time">
          <div class="flex justify-between items-center">
            Posted At
            <p-sortIcon field="created_date_time" />
          </div>
        </th>
        <th pResizableColumn pSortableColumn="updated_by">
          <div class="flex justify-between items-center">
            Last Updated By
            <p-sortIcon field="updated_by" />
            <p-columnFilter
              field="updated_by"
              matchMode="in"
              display="menu"
              [showMatchModes]="false"
              [showOperator]="false"
              [showAddButton]="false"
              class="ml-auto"
            >
              <ng-template
                pTemplate="filter"
                let-value
                let-filter="filterCallback"
              >
                <p-multiSelect
                  [options]="updatedByOptions"
                  optionLabel="label"
                  optionValue="value"
                  [filter]="true"
                  filterBy="label"
                  [showClear]="true"
                  placeholder="Select users"
                  [ngModel]="value"
                  (onChange)="filter($event.value)"
                  (onClear)="filter([])"
                  styleClass="w-full"
                ></p-multiSelect>
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        @if (shouldShowSaveColumn()) {
          <th pResizableColumn style="width: 1rem"></th>
        }
      </tr>
    </ng-template>
    <ng-template #body let-repayment let-ri="rowIndex">
      @if (isLoading && !loadMore && ri === 0) {
        <tr *ngFor="let _ of [1, 2, 3, 4, 5, 6, 7]">
          <td><p-skeleton styleClass="w-full h-1rem" /></td>
          <td *ngFor="let col of columns">
            <p-skeleton styleClass="w-full h-1rem" />
          </td>
          @if (shouldShowSaveColumn()) {
            <td><p-skeleton styleClass="w-full h-1rem" /></td>
          }
        </tr>
      }
      <tr
        [class.deleted-row]="repayment.deleted"
        [class.staged-row]="!!sourceFileId && repayment.staged"
        [class.saved-row]="
          !!sourceFileId && !repayment.deleted && !repayment.staged
        "
        [class.unsynced-row]="!sourceFileId && repayment.staged"
        [class.unsaved-marker-row]="isRepaymentUnsaved(repayment)"
        *ngIf="(!isLoading || loadMore) && (!pendingQueryToken || loadMore)"
      >
        <td>
          <p-tableCheckbox
            [value]="repayment"
            [disabled]="!canEdit && !canDelete"
          />
        </td>
        <td
          [attr.data-empty]="repayment.repayment_date ? null : true"
          [class.editable-cell-active]="
            isCellEditing(repayment, 'repayment_date')
          "
        >
          @if (isCellEditing(repayment, 'repayment_date')) {
            <p-datepicker
              inputId="repayment-date-{{ repayment.id }}"
              [ngModel]="editDraftValue"
              (ngModelChange)="onEditableDateChange(repayment, $event)"
              (onHide)="cancelActiveCellEdit()"
              appendTo="body"
              dateFormat="dd/mm/yy"
              dataType="string"
              [showIcon]="true"
              styleClass="w-full editable-cell-control"
            />
          } @else {
            <button
              type="button"
              class="editable-cell-button"
              (click)="activateCellEdit(repayment, 'repayment_date', $event)"
              [disabled]="!canEdit || repayment.deleted"
              [pTooltip]="activeOverflowTooltip"
              tooltipPosition="top"
              (mouseenter)="updateOverflowTooltip(repaymentDateText)"
              (mouseleave)="clearOverflowTooltip()"
            >
              <span
                #repaymentDateText
                [class.empty-cell-text]="!repayment.repayment_date"
                [attr.data-empty-label]="'Add Repayment Date'"
              >
                {{ repayment.repayment_date || '' }}
              </span>
            </button>
          }
        </td>

        <td
          class="left-aligned-col"
          [attr.data-empty]="repayment.description ? null : true"
          [class.editable-cell-active]="isCellEditing(repayment, 'description')"
        >
          @if (isCellEditing(repayment, 'description')) {
            <p-dropdown
              [options]="descriptionOptions"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              panelStyleClass="inline-editor-overlay"
              placeholder="Select description"
              [ngModel]="editDraftValue"
              (onChange)="onDescriptionDropdownChange(repayment, $event)"
              (onHide)="cancelActiveCellEdit()"
              styleClass="w-full editable-cell-control"
            ></p-dropdown>
          } @else {
            <button
              type="button"
              class="editable-cell-button"
              (click)="activateCellEdit(repayment, 'description', $event)"
              [disabled]="!canEdit || repayment.deleted"
              [pTooltip]="activeOverflowTooltip"
              tooltipPosition="top"
              (mouseenter)="updateOverflowTooltip(descriptionText)"
              (mouseleave)="clearOverflowTooltip()"
            >
              <span
                #descriptionText
                [class.empty-cell-text]="!repayment.description"
                [attr.data-empty-label]="'Add Description'"
              >
                {{ repayment.description || '' }}
              </span>
            </button>
          }
        </td>

        @if (!sourceFileId) {
          <td class="amount-col">
            <span
              class="editable-cell-button editable-cell-button-amount non-editable-cell-display"
            >
              {{
                hasValue(repayment.previous_balance)
                  ? (repayment.previous_balance | currency: 'GBP')
                  : ''
              }}
            </span>
          </td>
        }
        <td
          class="amount-col"
          [attr.data-empty]="hasValue(repayment.payment_amount) ? null : true"
          [class.editable-cell-active]="
            isCellEditing(repayment, 'payment_amount')
          "
        >
          @if (isCellEditing(repayment, 'payment_amount')) {
            <input
              pInputText
              type="text"
              class="editable-cell-input"
              [ngModel]="editDraftValue"
              (ngModelChange)="editDraftValue = $event"
              (blur)="saveActiveCell(repayment)"
              (keydown.enter)="onEditableAmountEnter($event, repayment)"
              (keydown.escape)="cancelActiveCellEdit($event)"
            />
          } @else {
            <button
              type="button"
              class="editable-cell-button editable-cell-button-amount"
              (click)="activateCellEdit(repayment, 'payment_amount', $event)"
              [disabled]="!canEdit || repayment.deleted"
              [pTooltip]="activeOverflowTooltip"
              tooltipPosition="top"
              (mouseenter)="updateOverflowTooltip(amountText)"
              (mouseleave)="clearOverflowTooltip()"
            >
              <span
                #amountText
                [class.empty-cell-text]="!hasValue(repayment.payment_amount)"
                [attr.data-empty-label]="'Add Amount'"
              >
                {{
                  repayment.payment_amount
                    ? (repayment.payment_amount | currency: 'GBP')
                    : ''
                }}
              </span>
            </button>
          }
        </td>
        @if (!sourceFileId) {
          <td class="amount-col">
            <span
              class="editable-cell-button editable-cell-button-amount non-editable-cell-display"
            >
              {{
                hasValue(repayment.balance)
                  ? (repayment.balance | currency: 'GBP')
                  : ''
              }}
            </span>
          </td>
        }
        <td class="amount-col">
          <span
            class="editable-cell-button editable-cell-button-amount non-editable-cell-display"
            [pTooltip]="activeOverflowTooltip"
            tooltipPosition="top"
            (mouseenter)="updateOverflowTooltip(cardTransactionsText)"
            (mouseleave)="clearOverflowTooltip()"
          >
            <span #cardTransactionsText>
              {{
                repayment.card_transactions
                  ? (repayment.card_transactions | currency: 'GBP')
                  : ''
              }}
            </span>
          </span>
        </td>
        <td
          [attr.data-empty]="repayment.data_source ? null : true"
          [class.editable-cell-active]="isCellEditing(repayment, 'data_source')"
        >
          @if (isCellEditing(repayment, 'data_source')) {
            <p-dropdown
              [options]="dataSourceOptions"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              panelStyleClass="inline-editor-overlay"
              [filter]="true"
              filterBy="label"
              filterPlaceholder="Search data sources"
              [showClear]="false"
              placeholder="Select data source"
              [ngModel]="editDraftValue"
              (onChange)="onEditableDropdownChange(repayment, $event.value)"
              (onHide)="cancelActiveCellEdit()"
              styleClass="w-full editable-cell-control"
            ></p-dropdown>
          } @else {
            <button
              type="button"
              class="editable-cell-button editable-cell-text-button"
              (click)="activateCellEdit(repayment, 'data_source', $event)"
              [disabled]="!canEdit || repayment.deleted"
              [pTooltip]="activeOverflowTooltip"
              tooltipPosition="top"
              (mouseenter)="updateOverflowTooltip(dataSourceText)"
              (mouseleave)="clearOverflowTooltip()"
            >
              <span
                #dataSourceText
                class="cell-ellipsis"
                [class.empty-cell-text]="!repayment.data_source"
                [attr.data-empty-label]="'Add Data Source'"
              >
                {{ repayment.data_source || '' }}
              </span>
            </button>
          }
        </td>
        <td
          class="x365-split-cell"
          [class.editable-cell-active]="isCellEditing(repayment, 'x365_split')"
        >
          @if (isCellEditing(repayment, 'x365_split')) {
            <input
              pInputText
              type="text"
              class="editable-cell-input"
              [ngModel]="editDraftValue"
              (ngModelChange)="editDraftValue = $event"
              (blur)="saveActiveCell(repayment)"
              (keydown.enter)="onEditableAmountEnter($event, repayment)"
              (keydown.escape)="cancelActiveCellEdit($event)"
            />
          } @else {
            <button
              type="button"
              class="editable-cell-button editable-cell-button-amount"
              [class.editable-cell-button-disabled]="
                !canEdit ||
                repayment.deleted ||
                is365SplitNotApplicable(repayment)
              "
              [disabled]="
                !canEdit ||
                repayment.deleted ||
                is365SplitNotApplicable(repayment)
              "
              (click)="activateCellEdit(repayment, 'x365_split', $event)"
              [pTooltip]="activeOverflowTooltip"
              tooltipPosition="top"
              (mouseenter)="updateOverflowTooltip(x365SplitText)"
              (mouseleave)="clearOverflowTooltip()"
            >
              <span
                #x365SplitText
                [class.empty-cell-text]="
                  !is365SplitNotApplicable(repayment) &&
                  !get365SplitDisplay(repayment)
                "
                [attr.data-empty-label]="'Add Split'"
                [class.not-applicable-cell-text]="
                  is365SplitNotApplicable(repayment)
                "
                >{{ get365SplitDisplay(repayment) }}</span
              >
            </button>
          }
        </td>
        <td class="comments-col left-aligned-col">
          <button
            type="button"
            class="comments-cell"
            [class.comments-cell-empty]="!repayment.comments"
            [pTooltip]="activeOverflowTooltip"
            tooltipPosition="top"
            (click)="openCommentsDialog(repayment, $event)"
            [disabled]="!canEdit || repayment.deleted"
            (mouseenter)="updateOverflowTooltip(commentsText)"
            (mouseleave)="clearOverflowTooltip()"
          >
            <span #commentsText class="comments-text">{{
              getCommentsDisplay(repayment.comments)
            }}</span>
          </button>
        </td>
        <td
          class="left-aligned-col"
          [attr.data-empty]="
            isTerminalNotApplicable(repayment) ||
            hasTerminalAssignment(repayment)
              ? null
              : true
          "
          [class.editable-cell-active]="isCellEditing(repayment, 'terminal_id')"
        >
          @if (isCellEditing(repayment, 'terminal_id')) {
            <p-dropdown
              [options]="getTerminalOptionsForRepayment(repayment)"
              optionLabel="name"
              optionValue="id"
              appendTo="body"
              [panelStyleClass]="
                shouldFlipActiveRelationDropdown
                  ? 'inline-relation-dropdown-overlay'
                  : ''
              "
              [filter]="true"
              filterBy="name"
              (onFilter)="
                onRelationDropdownFilter(
                  'terminal_id',
                  $event.filter,
                  repayment
                )
              "
              [showClear]="true"
              placeholder="Select terminal"
              [emptyMessage]="getTerminalEmptyMessage(repayment)"
              [ngModel]="editDraftValue"
              (onChange)="onEditableDropdownChange(repayment, $event.value)"
              (onHide)="cancelActiveCellEdit()"
              styleClass="w-full editable-cell-control"
            ></p-dropdown>
          } @else {
            <div class="editable-cell-wrapper">
              <button
                type="button"
                class="editable-cell-button editable-cell-text-button relation-cell-text-button"
                [class.editable-cell-button-disabled]="
                  !canEdit ||
                  repayment.deleted ||
                  isTerminalNotApplicable(repayment) ||
                  isEmbeddedLockedField('terminal_id')
                "
                style="flex: 1 1 auto; min-width: 0"
                (click)="
                  activateRelationCellEdit(repayment, 'terminal_id', $event)
                "
                [disabled]="
                  !canEdit ||
                  repayment.deleted ||
                  isTerminalNotApplicable(repayment) ||
                  isEmbeddedLockedField('terminal_id')
                "
                [pTooltip]="activeOverflowTooltip"
                tooltipPosition="top"
                (mouseenter)="updateOverflowTooltip(terminalText)"
                (mouseleave)="clearOverflowTooltip()"
              >
                <span
                  #terminalText
                  [class.empty-cell-text]="
                    !isTerminalNotApplicable(repayment) &&
                    !hasTerminalSelection(repayment)
                  "
                  [attr.data-empty-label]="'Add Terminal'"
                  [class.not-applicable-cell-text]="
                    isTerminalNotApplicable(repayment)
                  "
                >
                  {{ getTerminalDisplay(repayment) }}
                </span>
              </button>
              @if (
                !isTerminalNotApplicable(repayment) &&
                canShowQuickFilterAction(repayment.terminals?.name)
              ) {
                <button
                  type="button"
                  class="cell-filter-action"
                  pTooltip="Add to filter"
                  tooltipPosition="bottom"
                  (click)="
                    addRelationToQuickFilter(
                      'terminal',
                      repayment.terminals,
                      $event
                    )
                  "
                >
                  <i class="pi pi-filter"></i>
                </button>
              }
            </div>
          }
        </td>
        <td
          class="left-aligned-col"
          [attr.data-empty]="hasCashAdvanceSelection(repayment) ? null : true"
          [class.editable-cell-active]="
            isCellEditing(repayment, 'cash_advance_id')
          "
        >
          @if (isCellEditing(repayment, 'cash_advance_id')) {
            <p-dropdown
              [options]="getCashAdvanceOptionsForRepayment(repayment)"
              optionLabel="name"
              optionValue="id"
              appendTo="body"
              [panelStyleClass]="
                shouldFlipActiveRelationDropdown
                  ? 'inline-relation-dropdown-overlay'
                  : ''
              "
              [filter]="true"
              filterBy="name"
              (onFilter)="
                onRelationDropdownFilter(
                  'cash_advance_id',
                  $event.filter,
                  repayment
                )
              "
              [showClear]="true"
              placeholder="Select cash advance"
              [emptyMessage]="getCashAdvanceEmptyMessage(repayment)"
              [ngModel]="editDraftValue"
              (onChange)="onEditableDropdownChange(repayment, $event.value)"
              (onHide)="cancelActiveCellEdit()"
              styleClass="w-full editable-cell-control"
            >
              <ng-template pTemplate="item" let-cashAdvance>
                <span
                  style="display: inline-block; width: 0.5rem; height: 0.5rem; margin-right: 0.5rem; border-radius: 50%"
                  [style.background-color]="
                    cashAdvance.activeCashAdvance ? '#22c55e' : '#9ca3af'
                  "
                  [pTooltip]="
                    cashAdvance.activeCashAdvance ? 'Active' : 'Inactive'
                  "
                  tooltipPosition="right"
                ></span>
                <span>{{ cashAdvance.name }}</span>
              </ng-template>
            </p-dropdown>
          } @else {
            <div class="editable-cell-wrapper">
              <button
                type="button"
                class="editable-cell-button editable-cell-text-button relation-cell-text-button"
                [class.editable-cell-button-disabled]="
                  !canEdit ||
                  repayment.deleted ||
                  isEmbeddedLockedField('cash_advance_id')
                "
                style="flex: 1 1 auto; min-width: 0"
                (click)="
                  activateRelationCellEdit(repayment, 'cash_advance_id', $event)
                "
                [disabled]="
                  !canEdit ||
                  repayment.deleted ||
                  isEmbeddedLockedField('cash_advance_id')
                "
                [pTooltip]="activeOverflowTooltip"
                tooltipPosition="top"
                (mouseenter)="updateOverflowTooltip(cashAdvanceText)"
                (mouseleave)="clearOverflowTooltip()"
              >
                <span
                  #cashAdvanceText
                  [class.empty-cell-text]="!hasCashAdvanceSelection(repayment)"
                  [attr.data-empty-label]="'Add Cash Advance'"
                >
                  {{ getCashAdvanceDisplay(repayment) }}
                </span>
              </button>
              @if (canShowQuickFilterAction(repayment.cash_advances?.name)) {
                <button
                  type="button"
                  class="cell-filter-action"
                  pTooltip="Add to filter"
                  tooltipPosition="bottom"
                  (click)="
                    addRelationToQuickFilter(
                      'cashAdvance',
                      repayment.cash_advances,
                      $event
                    )
                  "
                >
                  <i class="pi pi-filter"></i>
                </button>
              }
            </div>
          }
        </td>
        <td
          class="left-aligned-col"
          [attr.data-empty]="hasMerchantSelection(repayment) ? null : true"
          [class.editable-cell-active]="isCellEditing(repayment, 'merchant_id')"
        >
          @if (isCellEditing(repayment, 'merchant_id')) {
            <p-dropdown
              [options]="merchantOptions"
              optionLabel="name"
              optionValue="id"
              appendTo="body"
              [panelStyleClass]="
                shouldFlipActiveRelationDropdown
                  ? 'inline-relation-dropdown-overlay'
                  : ''
              "
              [filter]="true"
              filterBy="name,customerNumber"
              (onFilter)="
                onRelationDropdownFilter(
                  'merchant_id',
                  $event.filter,
                  repayment
                )
              "
              [showClear]="true"
              placeholder="Select merchant"
              [ngModel]="editDraftValue"
              (onChange)="onEditableDropdownChange(repayment, $event.value)"
              (onHide)="cancelActiveCellEdit()"
              styleClass="w-full editable-cell-control"
            ></p-dropdown>
          } @else {
            <div class="editable-cell-wrapper">
              <button
                type="button"
                class="editable-cell-button editable-cell-text-button relation-cell-text-button"
                [class.editable-cell-button-disabled]="
                  !canEdit ||
                  repayment.deleted ||
                  isEmbeddedLockedField('merchant_id')
                "
                style="flex: 1 1 auto; min-width: 0"
                (click)="
                  activateRelationCellEdit(repayment, 'merchant_id', $event)
                "
                [disabled]="
                  !canEdit ||
                  repayment.deleted ||
                  isEmbeddedLockedField('merchant_id')
                "
                [pTooltip]="activeOverflowTooltip"
                tooltipPosition="top"
                (mouseenter)="updateOverflowTooltip(merchantText)"
                (mouseleave)="clearOverflowTooltip()"
              >
                <span
                  #merchantText
                  [class.empty-cell-text]="!hasMerchantSelection(repayment)"
                  [attr.data-empty-label]="'Add Merchant'"
                >
                  {{ getMerchantDisplay(repayment) }}
                </span>
              </button>
              @if (canShowQuickFilterAction(repayment.merchants?.name)) {
                <button
                  type="button"
                  class="cell-filter-action"
                  pTooltip="Add to filter"
                  tooltipPosition="bottom"
                  (click)="
                    addRelationToQuickFilter(
                      'merchant',
                      repayment.merchants,
                      $event
                    )
                  "
                >
                  <i class="pi pi-filter"></i>
                </button>
              }
            </div>
          }
        </td>
        <td class="left-aligned-col">
          <span class="cell-ellipsis">
            {{
              formatCreatedDate(
                repayment.created_date_time ?? repayment.created_date
              )
            }}
          </span>
        </td>
        <td class="left-aligned-col">
          <span
            #updatedByText
            class="cell-ellipsis"
            [pTooltip]="activeOverflowTooltip"
            tooltipPosition="top"
            (mouseenter)="updateOverflowTooltip(updatedByText)"
            (mouseleave)="clearOverflowTooltip()"
            >{{ repayment.updated_by || '' }}</span
          >
        </td>
        @if (shouldShowSaveColumn()) {
          @if (shouldShowInProgressSaveButton(repayment)) {
            <td class="save-to-repayments-col">
              <button
                pButton
                pRipple
                type="button"
                icon="pi pi-save"
                (click)="promoteRepayment(repayment, $event)"
                [loading]="isRepaymentActionPending(repayment, 'promote')"
                [disabled]="
                  !canEdit || isRepaymentActionPending(repayment, 'promote')
                "
                text
                rounded
                severity="success"
                pTooltip="Commit to Salesforce"
                tooltipStyleClass="save-action-tooltip"
                tooltipPosition="bottom"
              ></button>
            </td>
          } @else if (shouldShowManualSaveButton(repayment)) {
            <td class="save-to-repayments-col">
              <button
                pButton
                pRipple
                type="button"
                icon="pi pi-save"
                (click)="saveRepaymentRow(repayment, $event)"
                [loading]="isRepaymentActionPending(repayment)"
                [disabled]="!canEdit || isRepaymentActionPending(repayment)"
                text
                rounded
                severity="success"
                [pTooltip]="
                  sourceFileId ? 'Save to File' : 'Commit to Salesforce'
                "
                tooltipStyleClass="save-action-tooltip"
                tooltipPosition="bottom"
              ></button>
            </td>
          } @else {
            <td></td>
          }
        }
      </tr>

      @if (ri === (repayments?.length ?? 0) - 1 && hasMoreRepayments) {
        <ng-container>
          <tr *ngFor="let _ of [1, 2, 3]">
            <td><p-skeleton styleClass="w-full h-1rem" /></td>
            <td *ngFor="let col of columns">
              <p-skeleton styleClass="w-full h-1rem" />
            </td>
            @if (shouldShowSaveColumn()) {
              <td><p-skeleton styleClass="w-full h-1rem" /></td>
            }
          </tr>
        </ng-container>
      }
    </ng-template>
    <ng-template #emptymessage>
      @if (!canView) {
      } @else if (isLoading || repayments === null || pendingQueryToken) {
        <tr *ngFor="let _ of [1, 2, 3, 4, 5, 6, 7]">
          <td><p-skeleton styleClass="w-full h-1rem" /></td>
          <td *ngFor="let col of columns">
            <p-skeleton styleClass="w-full h-1rem" />
          </td>
          @if (shouldShowSaveColumn()) {
            <td><p-skeleton styleClass="w-full h-1rem" /></td>
          }
        </tr>
      } @else {
        <tr class="p-empty-row">
          <td
            [attr.colspan]="
              columns.length + 1 + (shouldShowSaveColumn() ? 1 : 0)
            "
          >
            No repayments.
          </td>
        </tr>
      }
    </ng-template>
  </p-table>
</div>
@if (bulkEditJob) {
  <div class="bulk-edit-progress" role="status" aria-live="polite">
    <p-progress-spinner strokeWidth="4" [style]="{ width: '1.25rem', height: '1.25rem' }" />
    <span>Updating repayments: {{ bulkEditProgressPercent() }}% ({{ bulkEditJob.completed_rows }} of {{ bulkEditJob.total_rows }})</span>
  </div>
}
<div *ngIf="!canView" class="p-4">
  You do not have permission to view repayments. Please contact your
  administrator.
</div>

<p-toast position="top-right" />
<p-confirmpopup key="standardPopup" />
<p-dialog
  header="Bulk edit repayments"
  [(visible)]="bulkEditDialogVisible"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '46rem', maxWidth: '95vw' }"
>
  <p class="bulk-edit-intro">
    Update the selected {{ selectedRepaymentsCount }} repayments. Only
    fields set below will be changed.
  </p>

  <div class="bulk-edit-form">
    <div class="bulk-edit-row">
      <label for="bulk-repayment-date">Repayment Date</label>
      <p-datepicker
        inputId="bulk-repayment-date"
        [(ngModel)]="bulkEditValues.repayment_date"
        dateFormat="dd/mm/yy"
        [showIcon]="true"
        styleClass="w-full"
      />
    </div>
    <div class="bulk-edit-row">
      <label for="bulk-description">Description</label>
      <p-dropdown
        inputId="bulk-description"
        [options]="descriptionOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="bulkEditValues.description"
        [showClear]="true"
        placeholder="Leave unchanged"
        styleClass="w-full"
      />
    </div>
    <div class="bulk-edit-row">
      <label for="bulk-data-source">Data Source</label>
      <p-dropdown
        inputId="bulk-data-source"
        [options]="dataSourceOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="bulkEditValues.data_source"
        [showClear]="true"
        placeholder="Leave unchanged"
        styleClass="w-full"
      />
    </div>
    <div class="bulk-edit-row">
      <label for="bulk-split">365 Split</label>
      <p-inputNumber
        inputId="bulk-split"
        [(ngModel)]="bulkEditValues.x365_split"
        suffix="%"
        [minFractionDigits]="0"
        [maxFractionDigits]="2"
        placeholder="Leave unchanged"
        styleClass="w-full"
      />
    </div>
    <div class="bulk-edit-row bulk-edit-row--comments">
      <label for="bulk-comments">Comments</label>
      <textarea
        id="bulk-comments"
        pInputTextarea
        [(ngModel)]="bulkEditValues.comments"
        rows="3"
        class="w-full"
        placeholder="Leave unchanged"
      ></textarea>
    </div>
    <div class="bulk-edit-row">
      <label for="bulk-terminal">Terminal</label>
      <p-dropdown
        inputId="bulk-terminal"
        [options]="terminalOptions"
        optionLabel="name"
        optionValue="id"
        [(ngModel)]="bulkEditValues.terminal_id"
        [filter]="true"
        filterBy="name"
        (onFilter)="onRelationDropdownFilter('terminal_id', $event.filter)"
        [showClear]="true"
        placeholder="Leave unchanged"
        styleClass="w-full"
      />
    </div>
    <div class="bulk-edit-row">
      <label for="bulk-cash-advance">Cash Advance</label>
      <p-dropdown
        inputId="bulk-cash-advance"
        [options]="cashAdvanceOptions"
        optionLabel="name"
        optionValue="id"
        [(ngModel)]="bulkEditValues.cash_advance_id"
        [filter]="true"
        filterBy="name"
        (onFilter)="onRelationDropdownFilter('cash_advance_id', $event.filter)"
        [showClear]="true"
        placeholder="Leave unchanged"
        styleClass="w-full"
      />
    </div>
    <div class="bulk-edit-row">
      <label for="bulk-merchant">Merchant</label>
      <p-dropdown
        inputId="bulk-merchant"
        [options]="merchantOptions"
        optionLabel="name"
        optionValue="id"
        [(ngModel)]="bulkEditValues.merchant_id"
        [filter]="true"
        filterBy="name,customerNumber"
        (onFilter)="onRelationDropdownFilter('merchant_id', $event.filter)"
        [showClear]="true"
        placeholder="Leave unchanged"
        styleClass="w-full"
      />
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="bulk-edit-actions">
      <p-button
        label="Cancel"
        severity="secondary"
        [outlined]="true"
        (onClick)="bulkEditDialogVisible = false"
      />
      <p-button
        label="Apply changes"
        icon="pi pi-check"
        (onClick)="applyBulkEdit()"
        [loading]="isBulkActionPending('edit')"
        [disabled]="!hasBulkEditChanges() || isBulkActionPending('edit')"
      />
    </div>
  </ng-template>
</p-dialog>
<p-dialog
  header="Comments"
  [(visible)]="commentsDialogVisible"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '40rem', maxWidth: '95vw' }"
  (onShow)="focusCommentsDialogInput()"
  (onHide)="closeCommentsDialog()"
>
  <div class="comments-dialog-body">
    <textarea
      #commentsDialogInput
      pInputTextarea
      [(ngModel)]="commentsDialogValue"
      [disabled]="!canEdit"
      rows="10"
      class="comments-dialog-textarea"
      placeholder="Enter comments"
    ></textarea>
  </div>
  <ng-template pTemplate="footer">
    <div class="comments-dialog-actions">
      <p-button
        label="Cancel"
        severity="secondary"
        [outlined]="true"
        (onClick)="closeCommentsDialog()"
      />
      <p-button
        label="Save"
        (onClick)="saveComments()"
        [loading]="isSavingComments"
        [disabled]="!canEdit || !canSaveComments || isSavingComments"
      />
    </div>
  </ng-template>
</p-dialog>
